// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { ILevelDomainListDto } from 'src/app/infrastructure/models/level-domain-list-dto';

export const pageListDto = {
    requestedDomainUser_Guid: 'requestedDomainUser_Guid',
    domain_Guid: 'domain_Guid',
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    displayName: 'displayName',
    isTab: 'isTab',
    inactive: 'inactive',
    deleted: 'deleted',
} as const;

export type TPageListDto = (typeof pageListDto)[keyof typeof pageListDto];

export interface IPageListDto extends ILevelDomainListDto {
    [pageListDto.requestedDomainUser_Guid]: string | null;
    [pageListDto.domain_Guid]: string | null;
    [pageListDto.guid]: string | null;
    [pageListDto.nr]: number | null;
    [pageListDto.name]: string | null;
    [pageListDto.displayName]: string | null;
    [pageListDto.isTab]: boolean | null;
    [pageListDto.inactive]: boolean | null;
    [pageListDto.deleted]: boolean | null;
}

export class PageListDto
    implements IPageListDto
{
    [pageListDto.requestedDomainUser_Guid]: string | null = null;
    [pageListDto.domain_Guid]: string | null = null;
    [pageListDto.guid]: string | null = null;
    [pageListDto.nr]: number | null = null;
    [pageListDto.name]: string | null = null;
    [pageListDto.displayName]: string | null = null;
    [pageListDto.isTab]: boolean | null = null;
    [pageListDto.inactive]: boolean | null = null;
    [pageListDto.deleted]: boolean | null = null;

    private constructor(
        modelData: any, // IPageListData (geen import: voorkomt een assets → features-afhankelijkheid)
    ) {
        this[pageListDto.guid] = modelData?.guid ?? null;
        this[pageListDto.nr] = modelData?.nr ?? null;
        this[pageListDto.name] = modelData?.name ?? null;
        this[pageListDto.displayName] = modelData?.displayName ?? null;
        this[pageListDto.isTab] = modelData?.isTab ?? null;
        this[pageListDto.inactive] = modelData?.inactive ?? null;
        this[pageListDto.deleted] = modelData?.deleted ?? null;
    }

    static create(modelData?: any | null): IPageListDto | null {
        return modelData ? new PageListDto(modelData) : null;
    }
}
